import { Progress } from "antd";
import React, { useMemo } from "react";
import { defaultFuncAndData } from "../../../utils/defaultData";

function TitleProgressColumnsStudents({
  title,
  countUser,
  allUsers,
  isLightTheme = false,
}) {
  const calcPercent = useMemo(() => {
    return Math.round((countUser / allUsers) * 100);
  }, [countUser, allUsers]);
  return (
    <div className="header_progress_student">
      <div>
        {title} {countUser}
      </div>
      <Progress
        type="dashboard"
        percent={calcPercent}
        gapDegree={1}
        strokeColor={defaultFuncAndData.calcColorPercentProgress(calcPercent)}
        width={42}
        height={42}
        format={(percent) => percent}
        trailColor={isLightTheme ? "#E2E8F0" : "#474C5A"}
        strokeWidth={20}
      />
    </div>
  );
}

export default TitleProgressColumnsStudents;
